import { Fancybox } from '@fancyapps/ui';

export class FancyboxApp {
  constructor() {}

  init() {
    Fancybox.bind('.card-product-images-item', {
      autoFocus: false,
      infinite: true,
      placeFocusBack: false,
      Thumbs: {
        autoStart: false,
      },
      Toolbar: {
        display: [
          { id: 'prev', position: 'right' },
          { id: 'next', position: 'right' },
          'close',
        ],
      },
    });
  }
}
